import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { useRouter } from 'next/router'
import { DM_Mono, Fraunces, Hanken_Grotesk } from 'next/font/google'
import { MotionConfig } from 'motion/react'
import { SmoothScroll } from '@/components/generals/smooth-scroll'
import { ToneProvider } from '@/components/generals/tone'
import { IntroProvider } from '@/components/generals/intro'
import { HeaderStateProvider } from '@/components/generals/header-state'
import { SiteFrame } from '@/components/generals/site-frame'

const sans = Hanken_Grotesk({
    subsets: ['latin']
})

const mono = DM_Mono({
    subsets: ['latin'],
    weight: ['300', '400', '500']
})

const heading = Fraunces({
    subsets: ['latin'],
    style: ['normal', 'italic'],
    axes: ['SOFT', 'opsz']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    const router = useRouter()
    const routeKey = router.asPath.split(/[?#]/)[0]

    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <MotionConfig reducedMotion='user'>
                <SmoothScroll>
                    <ToneProvider>
                        <IntroProvider>
                            <HeaderStateProvider>
                                <SiteFrame routeKey={routeKey}>
                                    <Component {...pageProps} />
                                </SiteFrame>
                            </HeaderStateProvider>
                        </IntroProvider>
                    </ToneProvider>
                </SmoothScroll>
            </MotionConfig>
        </div>
    )
}

export default App
